import API from 'API/index'
import {enqueueSnackbar as enqueueSnackbarAction} from 'store/actions/notifier'
import * as typeNotifier from 'shared/typeNotifications'
import * as informationMessages from 'constants/infoMessages'

export const START_LOAD_OJ = 'START_LOAD_OJ'
export const SUCCESS_LOAD_OJ = 'SUCCESS_LOAD_OJ'
export const ERROR_LOAD_OJ = 'ERROR_LOAD_OJ'

export const DATE_CHANGE_FILTER_OJ = 'DATE_CHANGE_FILTER_OJ'
export const MULTI_SELECT_CHANGE_FILTER_OJ = 'MULTI_SELECT_CHANGE_FILTER_OJ'
export const APPLY_FILTER_OJ = 'APPLY_FILTER_OJ'
export const CLEAR_FILTER_OJ = 'CLEAR_FILTER_OJ'
export const SET_PAGINATION_OJ = 'SET_PAGINATION_OJ'
export const SET_SORTING_OJ = 'SET_SORTING_OJ'

export const CLEAR_OJ_ITEM = 'CLEAR_OJ_ITEM'

export const START_LOAD_OJ_ITEM = 'START_LOAD_OJ_ITEM'
export const SUCCESS_LOAD_OJ_ITEM = 'SUCCESS_LOAD_OJ_ITEM'
export const ERROR_LOAD_OJ_ITEM = 'ERROR_LOAD_OJ_ITEM'

export const START_CREATE_OJ_ITEM = 'START_CREATE_OJ_ITEM'
export const SUCCESS_CREATE_OJ_ITEM = 'SUCCESS_CREATE_OJ_ITEM'
export const ERROR_CREATE_OJ_ITEM = 'ERROR_CREATE_OJ_ITEM'

export const START_UPDATE_OJ_ITEM = 'START_UPDATE_OJ_ITEM'
export const SUCCESS_UPDATE_OJ_ITEM = 'SUCCESS_UPDATE_OJ_ITEM'
export const ERROR_UPDATE_OJ_ITEM = 'ERROR_UPDATE_OJ_ITEM'

export const START_LOAD_FILTER_OPTIONS_OJ = 'START_LOAD_FILTER_OPTIONS_OJ'
export const SUCCESS_LOAD_FILTER_OPTIONS_OJ = 'SUCCESS_LOAD_FILTER_OPTIONS_OJ'
export const ERROR_LOAD_FILTER_OPTIONS_OJ = 'ERROR_LOAD_FILTER_OPTIONS_OJ'

export const START_LOAD_PLANT_OJ = 'START_LOAD_PLANT_OJ'
export const SUCCESS_LOAD_PLANT_OJ = 'SUCCESS_LOAD_PLANT_OJ'
export const SELECT_CHANGE_PLANT_OJ = 'SELECT_CHANGE_PLANT_OJ'

export const START_LOAD_RECORD_TYPES_OJ = 'START_LOAD_RECORD_TYPES_OJ'
export const SUCCESS_LOAD_RECORD_TYPES_OJ = 'SUCCESS_LOAD_RECORD_TYPES_OJ'

export const START_LOAD_EQUIPMENTS_OJ = 'START_LOAD_EQUIPMENTS_OJ'
export const SUCCESS_LOAD_EQUIPMENTS_OJ = 'SUCCESS_LOAD_EQUIPMENTS_OJ'

export const START_CREATE_OJ_EQUIPMENT = 'START_CREATE_OJ_EQUIPMENT'
export const SUCCESS_CREATE_OJ_EQUIPMENT = 'SUCCESS_CREATE_OJ_EQUIPMENT'
export const ERROR_CREATE_OJ_EQUIPMENT = 'ERROR_CREATE_OJ_EQUIPMENT'
export const SET_ERROR_CREATE_OJ_EQUIPMENT_DUPLICATE = 'SET_ERROR_CREATE_OJ_EQUIPMENT_DUPLICATE'
export const CLEAR_ERROR_CREATE_OJ_EQUIPMENT_DUPLICATE = 'CLEAR_ERROR_CREATE_OJ_EQUIPMENT_DUPLICATE'
export const CLEAR_CREATED_EQUIPMENT_ID = 'CLEAR_CREATED_EQUIPMENT_ID'

export const START_LOAD_OJ_HISTORY = 'START_LOAD_OJ_HISTORY'
export const SUCCESS_LOAD_OJ_HISTORY = 'SUCCESS_LOAD_OJ_HISTORY'
export const ERROR_LOAD_OJ_HISTORY = 'ERROR_LOAD_OJ_HISTORY'

export const START_TOGGLE_IS_DEVIATION_OJ_ITEM = 'START_TOGGLE_IS_DEVIATION_OJ_ITEM'
export const SUCCESS_TOGGLE_IS_DEVIATION_OJ_ITEM = 'SUCCESS_TOGGLE_IS_DEVIATION_OJ_ITEM'
export const ERROR_TOGGLE_IS_DEVIATION_OJ_ITEM = 'ERROR_TOGGLE_IS_DEVIATION_OJ_ITEM'
export const CLEAR_TOGGLED_IS_DEVIATION_OJ_ITEM = 'CLEAR_TOGGLED_IS_DEVIATION_OJ_ITEM'

export const START_SENT_REQUEST_FOR_EDIT_OJ_ITEM = 'START_SENT_REQUEST_FOR_EDIT_OJ_ITEM'
export const START_SEND_REQUEST_FOR_EDIT_OJ_ITEM = 'START_SEND_REQUEST_FOR_EDIT_OJ_ITEM'
export const SUCCESS_SEND_REQUEST_FOR_EDIT_OJ_ITEM = 'SUCCESS_SEND_REQUEST_FOR_EDIT_OJ_ITEM'
export const ERROR_SEND_REQUEST_FOR_EDIT_OJ_ITEM = 'ERROR_SEND_REQUEST_FOR_EDIT_OJ_ITEM'

export const START_ACCEPT_REQUEST_FOR_EDIT_OJ_ITEM = 'START_ACCEPT_REQUEST_FOR_EDIT_OJ_ITEM'
export const SUCCESS_ACCEPT_REQUEST_FOR_EDIT_OJ_ITEM = 'SUCCESS_ACCEPT_REQUEST_FOR_EDIT_OJ_ITEM'
export const ERROR_ACCEPT_REQUEST_FOR_EDIT_OJ_ITEM = 'ERROR_ACCEPT_REQUEST_FOR_EDIT_OJ_ITEM'

export const START_REJECT_REQUEST_FOR_EDIT_OJ_ITEM = 'START_REJECT_REQUEST_FOR_EDIT_OJ_ITEM'
export const SUCCESS_REJECT_REQUEST_FOR_EDIT_OJ_ITEM = 'SUCCESS_REJECT_REQUEST_FOR_EDIT_OJ_ITEM'
export const ERROR_REJECT_REQUEST_FOR_EDIT_OJ_ITEM = 'ERROR_REJECT_REQUEST_FOR_EDIT_OJ_ITEM'

export const getOperationalJournal = (t, dto) => dispatch => {
  dispatch({type: START_LOAD_OJ})
  API.getOperationalJournalTable(dto)
    .then(({data}) => {
      dispatch({
        type: SUCCESS_LOAD_OJ,
        data,
      })
    })
    .catch(() => {
      dispatch({
        type: ERROR_LOAD_OJ,
      })
      dispatch(
        enqueueSnackbarAction({
          message: t(`infoMessages:${informationMessages.DATA_LOADING_ERROR}`),
          options: {
            variant: typeNotifier.ERROR,
          },
        }),
      )
      console.error('OJ_TABLE')
    })
}

export const getOJPlants = () => dispatch => {
  dispatch({type: START_LOAD_PLANT_OJ})
  API.getOJPlants()
    .then(({data}) => {
      dispatch({
        type: SUCCESS_LOAD_PLANT_OJ,
        plants: data,
      })
    })
    .catch(() => {
      console.error('ERROR_LOAD_PLANT_OJ')
    })
}

export const getOJRecordTypes = () => dispatch => {
  dispatch({type: START_LOAD_RECORD_TYPES_OJ})
  API.getOJRecordTypes()
    .then(({data}) => {
      dispatch({
        type: SUCCESS_LOAD_RECORD_TYPES_OJ,
        recordTypes: data,
      })
    })
    .catch(() => {
      console.error('ERROR_LOAD_RECORD_TYPES_OJ')
    })
}

export const getOJEquipments = id => dispatch => {
  dispatch({type: START_LOAD_EQUIPMENTS_OJ})
  API.getOJEquipments(id)
    .then(({data}) => {
      dispatch({
        type: SUCCESS_LOAD_EQUIPMENTS_OJ,
        equipmentDictionaries: data,
      })
    })
    .catch(() => {
      console.error('ERROR_LOAD_EQUIPMENTS_OJ')
    })
}

export const getOJItemById = id => dispatch => {
  dispatch({type: START_LOAD_OJ_ITEM})
  API.getOJItemById(id)
    .then(({data}) => {
      dispatch({
        type: SUCCESS_LOAD_OJ_ITEM,
        data,
      })
    })
    .catch(() => {
      dispatch({
        type: ERROR_LOAD_OJ_ITEM,
      })
    })
}

export const getOJFilterOptions = (t, id) => dispatch => {
  API.getOJFilterOptions(id)
    .then(({data}) => {
      dispatch({
        type: SUCCESS_LOAD_FILTER_OPTIONS_OJ,
        data,
      })
    })
    .catch(() => {
      dispatch({
        type: ERROR_LOAD_FILTER_OPTIONS_OJ,
      })
      dispatch(
        enqueueSnackbarAction({
          message: t(`infoMessages:${informationMessages.DATA_LOADING_ERROR}`),
          options: {
            variant: typeNotifier.ERROR,
          },
        }),
      )
      console.error('ERROR_LOAD_FILTER_OPTIONS_OJ')
    })
}

export const createOJItem = (param, t) => dispatch => {
  dispatch({type: START_CREATE_OJ_ITEM})
  API.createOJItem(param)
    .then(({data}) => {
      dispatch({
        type: SUCCESS_CREATE_OJ_ITEM,
        data,
      })
      dispatch(
        enqueueSnackbarAction({
          message: t(`infoMessages:${informationMessages.DATA_CREATE_SUCCESS}`),
          options: {
            variant: typeNotifier.SUCCESS,
          },
        }),
      )
    })
    .catch(() => {
      dispatch({
        type: ERROR_CREATE_OJ_ITEM,
      })
      dispatch(
        enqueueSnackbarAction({
          message: t(`infoMessages:${informationMessages.DATA_CREATE_ERROR}`),
          options: {
            variant: typeNotifier.ERROR,
          },
        }),
      )
    })
}

export const updateOJItem = (id, param, t) => dispatch => {
  dispatch({type: START_UPDATE_OJ_ITEM})
  API.updateOJItem(id, param)
    .then(({data}) => {
      dispatch({
        type: SUCCESS_UPDATE_OJ_ITEM,
        data,
      })
      dispatch(
        enqueueSnackbarAction({
          message: t(`infoMessages:${informationMessages.DATA_UPDATE_SUCCESS}`),
          options: {
            variant: typeNotifier.SUCCESS,
          },
        }),
      )
    })
    .catch(() => {
      dispatch({
        type: ERROR_UPDATE_OJ_ITEM,
      })
      dispatch(
        enqueueSnackbarAction({
          message: t(`infoMessages:${informationMessages.DATA_UPDATE_ERROR}`),
          options: {
            variant: typeNotifier.ERROR,
          },
        }),
      )
    })
}

export const toggleIsDeviationOJItem = (id, t) => dispatch => {
  dispatch({type: START_TOGGLE_IS_DEVIATION_OJ_ITEM})
  API.toggleIsDeviationOJItem(id)
    .then(({data}) => {
      dispatch({
        type: SUCCESS_TOGGLE_IS_DEVIATION_OJ_ITEM,
        data,
      })
    })
    .catch(() => {
      dispatch({
        type: ERROR_TOGGLE_IS_DEVIATION_OJ_ITEM,
      })
      dispatch(
        enqueueSnackbarAction({
          message: t(`infoMessages:${informationMessages.DATA_UPDATE_ERROR}`),
          options: {
            variant: typeNotifier.ERROR,
          },
        }),
      )
    })
}

export const sendRequestForEditRequestOJItem = (id, t) => dispatch => {
  dispatch({type: START_SEND_REQUEST_FOR_EDIT_OJ_ITEM})
  API.sendRequestForEditRequestOJItem(id)
    .then(() => {
      dispatch({type: SUCCESS_SEND_REQUEST_FOR_EDIT_OJ_ITEM})
      dispatch(
        enqueueSnackbarAction({
          message: t(`infoMessages:${informationMessages.EDIT_REQUEST_SEND_SUCCESS}`),
          options: {variant: typeNotifier.SUCCESS},
        }),
      )
    })
    .catch(error => {
      dispatch({type: ERROR_SEND_REQUEST_FOR_EDIT_OJ_ITEM})
      const is409 = error?.response?.status === 409
      dispatch(
        enqueueSnackbarAction({
          message: t(
            `infoMessages:${
              is409
                ? informationMessages.EDIT_REQUEST_SEND_CONFLICT
                : informationMessages.DATA_UPDATE_ERROR
            }`,
          ),
          options: {variant: is409 ? typeNotifier.WARNING : typeNotifier.ERROR},
        }),
      )
    })
}

export const acceptRequestForEditOJItem = (id, t) => dispatch => {
  dispatch({type: START_ACCEPT_REQUEST_FOR_EDIT_OJ_ITEM})
  API.acceptRequestForEditRecordItem(id)
    .then(() => {
      dispatch({type: SUCCESS_ACCEPT_REQUEST_FOR_EDIT_OJ_ITEM})
      dispatch(getOJItemById(id))
      dispatch(
        enqueueSnackbarAction({
          message: t(`infoMessages:${informationMessages.EDIT_REQUEST_ACCEPT_SUCCESS}`),
          options: {variant: typeNotifier.SUCCESS},
        }),
      )
    })
    .catch(() => {
      dispatch({type: ERROR_ACCEPT_REQUEST_FOR_EDIT_OJ_ITEM})
      dispatch(
        enqueueSnackbarAction({
          message: t(`infoMessages:${informationMessages.DATA_UPDATE_ERROR}`),
          options: {variant: typeNotifier.ERROR},
        }),
      )
    })
}

export const rejectRequestForEditOJItem = (id, t) => dispatch => {
  dispatch({type: START_REJECT_REQUEST_FOR_EDIT_OJ_ITEM})
  API.rejectRequestForEditRecordItem(id)
    .then(() => {
      dispatch({type: SUCCESS_REJECT_REQUEST_FOR_EDIT_OJ_ITEM})
      dispatch(getOJItemById(id))
      dispatch(
        enqueueSnackbarAction({
          message: t(`infoMessages:${informationMessages.EDIT_REQUEST_REJECT_WARNING}`),
          options: {variant: typeNotifier.WARNING},
        }),
      )
    })
    .catch(() => {
      dispatch({type: ERROR_REJECT_REQUEST_FOR_EDIT_OJ_ITEM})
      dispatch(
        enqueueSnackbarAction({
          message: t(`infoMessages:${informationMessages.DATA_UPDATE_ERROR}`),
          options: {variant: typeNotifier.ERROR},
        }),
      )
    })
}

export const createOJEquipment = (param, t) => dispatch => {
  dispatch({type: START_CREATE_OJ_EQUIPMENT})
  API.createOJEquipment(param)
    .then(({data}) => {
      dispatch({
        type: SUCCESS_CREATE_OJ_EQUIPMENT,
        data,
      })
      dispatch(
        enqueueSnackbarAction({
          message: t(`infoMessages:${informationMessages.EQUIPMENT_CREATE_SUCCESS}`),
          options: {
            variant: typeNotifier.SUCCESS,
          },
        }),
      )
    })
    .catch(error => {
      dispatch({type: ERROR_CREATE_OJ_EQUIPMENT})
      const is409 = error?.response?.status === 409

      if (is409) {
        dispatch({type: SET_ERROR_CREATE_OJ_EQUIPMENT_DUPLICATE})
      } else {
        dispatch(
          enqueueSnackbarAction({
            message: t(`infoMessages:${informationMessages.EQUIPMENT_CREATE_ERROR}`),
            options: {
              variant: typeNotifier.ERROR,
            },
          }),
        )
      }
    })
}

export const getOJItemHistory = (id, t) => dispatch => {
  dispatch({type: START_LOAD_OJ_HISTORY})
  API.getOJItemHistory(id)
    .then(({data}) => {
      dispatch({
        type: SUCCESS_LOAD_OJ_HISTORY,
        data,
      })
    })
    .catch(() => {
      dispatch({
        type: ERROR_LOAD_OJ_HISTORY,
      })
      dispatch(
        enqueueSnackbarAction({
          message: t(`infoMessages:${informationMessages.DATA_LOADING_ERROR}`),
          options: {
            variant: typeNotifier.ERROR,
          },
        }),
      )
    })
}
